module.exports = __webpack_public_path__ + "static/media/118.e818aad0.jpg";